module.exports = __webpack_public_path__ + "img/big_SP.14feb40c.jpg";